//
// Dialog for editing data fields.
// props:
//   data    - contains an object (e.g. from a DB query)
//               { name1: value1, name2: value2, ... }
//   onApply - function onApply(edited) -> void 
//               called with an object containing all data
//   onClose - function onClose() -> void
//               called when no edits are to be saved
//
import 'bootstrap/dist/js/bootstrap.min.js';
import Modal from "react-bootstrap/Modal";
import { useState, useEffect } from 'react';

import gUtilities from '../script/utilities';

const k_number_expression = "^[+-]?[0-9]+([.][0-9]+)?([eE][+-]?[0-9]+)?$";

const EditForm = (props) => {
    const [items, setItems] = useState([]);
    const [first, setFirst] = useState(true);
    const [isOpen, setIsOpen] = useState(true);

    if (first) {
        let target = buildItems(props.data);

        setItems(target);
        setFirst(false);
    }

    const hideModal = () => {
        setIsOpen(false);
    };

    function nameToTitle(name) {
        let title = "";

        let first = true;
        for (let c of name) {
            if (c == ' ') {
                return name; // literal
            }

            if (c == '_') {
                c = ' ';
                first = true;
            } else if (first) {
                c = c.toUpperCase(c);
                first = false;
            }

            title += c;
        }

        return title;
    }

    async function onApply() {
        let target = {};

        for (let item of items) {
            target[item.name] = item.value
        }

        try {
            hideModal();

            props.onApply(target);
        } catch(ex) {
            gUtilities.showError(props.title, `Failed to save data: ${ex}`);
        }
    }

    async function onClose() {
        try {
            hideModal();
            
            props.onClose();
        } catch(ex) {
            gUtilities.showError(props.title, `Failed to close: ${ex}`);
        }
    }

    function isNumber(item) {
        return item.type == "number";
    }

    function isText(item) {
        return item.type == "string";
    }

    function isBoolean(item) {
        return item.type == "boolean";
    }

    function widgetID(item) {
        return `w_EF_Item_${item.name}`;
    }

    function getWidget(id) {
        let widget = document.querySelector("#" + id);

        return widget;
    }

    function getValue(item) {
        let id = widgetID(item);
        let widget = getWidget(id);
        let value;

        if (isNumber(item)) {
            if (widget.value.match(k_number_expression)) {
                value = parseFloat(widget.value);
            } else {
                gUtilities.showError(item.title, "Value is not a valid number");
                value = item.value;
            }
        } else if (isBoolean(item)) {
            value = widget.checked;
        } else if (isText(item)) {
            value = widget.value;
        }

        return value;
    }

    function buildItems(data) {
        let target = [];
        let d;

        for (let name of Object.keys(data)) {
            d = {
                name: name,
                value: data[name],
                title: nameToTitle(name),
                type: typeof(data[name]),
                index: target.length
            };
            target.push(d);
        }

        return target;
    }

    function assign(changed) {
        let target = [];

        for (let item of items) {
            if (item.index == changed.index) {
                item.value = getValue(changed);
            }

            target.push(item);
        }

        setItems(target);
    }

    function setValues() {
        let widget;
        let id;

        for (let item of items) {
            id = widgetID(item);
            widget = getWidget(id);

            if (isBoolean(item)) {
                widget.checked = item.value;
            } else {
                widget.value = item.value;
            }
        }
    }

    useEffect(async () => {
        setValues();
    }, [items]);

    return (
        <div>
            <Modal show={isOpen}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{props.title}</h5>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            {
                                items.map((item) => (
                                    <div className="input-group">
                                    { isText(item) && 
                                    <>
                                        <label className="col-form-label mt-1" htmlFor={widgetID(item)}>{item.title}</label>
                                        <div className="input-group mb-1">
                                            <input type="text" className="form-control" id={widgetID(item)} placeholder={item.value} onBlur={() => assign(item)}></input>
                                        </div>
                                    </>
                                    }
                                    { isBoolean(item) && 
                                        <div className="input-group mb-1">
                                            <div className="form-check form-switch">
                                                <label className="form-check-label" for={"x"+widgetID(item)} >{item.title}</label>
                                                <input className="form-check-input" type="checkbox"  id={widgetID(item)} onClick={() => assign(item)}/>
                                            </div>
                                        </div>
                                    }
                                    { isNumber(item) && 
                                    <>
                                        <label className="col-form-label mt-1" htmlFor={widgetID(item)}>{item.title}</label>
                                        <div className="input-group mb-1">
                                            <input type="text" className="form-control" id={widgetID(item)} placeholder={item.value} onBlur={() => assign(item)}></input>
                                        </div>
                                    </>
                                    }
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={onClose}>Close</button>
                        <button type="button" className="btn btn-primary" onClick={onApply}>Apply</button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default EditForm;
